import AppConstant from '../../../config/app.constants';
import BaseController from '../common/service_ticket_parts.base.controller'

class ServiceTicketsPartsCreateController extends BaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, ServiceTicketPartsService, Modal, $translate) {

        super(Auth, $state, User, ServiceTicketPartsService, Modal, $translate)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.Modal = Modal;
        this.ServiceTicketPartsService = ServiceTicketPartsService;

        this.defaultModel = {
            currentBranch: this.User.getUser().branchId,
            label: null,
            serialNumber: null,
            sortOrder: 1,
            partCharge: null
        }

        this.model = angular.copy(this.defaultModel);

        this.serviceOrderParts = {
            results: [],
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            }
        };
    }

    $onInit() {

    }

    reset() {
        this.model = angular.copy(this.defaultModel);
    }

    create() {
        this.model.isCreate = true;
        this.Service.create({
            branchId: this.model.currentBranch,
            label: this.model.label,
            serialNumber: this.model.serialNumber,
            sortOrder: this.model.sortOrder,
            partCharge: this.model.partCharge
        })
            .then(() => {
                this.askCreate();
            })
            .catch((err) => {
                err.data.errors.map((e) => {
                    this.model.errorMessage = e.message;
                })
            })
            .finally(() => {
                this.model.isCreate = false;
            })
    }

}

export default ServiceTicketsPartsCreateController;


// WEBPACK FOOTER //
// ./client/app/components/service_ticket_parts/create/service_ticket_parts.create.controller.js